import { render, staticRenderFns } from "./geishuishenqing.vue?vue&type=template&id=caa8cefa&scoped=true&"
import script from "./geishuishenqing.vue?vue&type=script&lang=js&"
export * from "./geishuishenqing.vue?vue&type=script&lang=js&"
import style0 from "./geishuishenqing.vue?vue&type=style&index=0&id=caa8cefa&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "caa8cefa",
  null
  
)

export default component.exports